const Platforms = {
  DESKTOP: 'desktop',
  MOBILE: 'mobile',
} as const;

export default Platforms;
